const socialEvents = new EventDelegator([
    {
        selector: '#js-social',
        eventType: 'click',
        events:
            {
                notificationcentre: (e, d) =>
                {
                    toggleNotificationCentre(d.notificationcentre);
                }
            }
    }]);

function toggleNotificationCentre(target) {
    target = $('.notifications-centre__' + target);
    target.siblings().removeClass('active');
    target.hasClass('active') ? target.removeClass('active') : target.addClass('active');
}

function revealMentions() {
    const socialMentions = $('.social__mentions');
    $('.social__mentions').addClass('social__mentions--revealed');
    $('.social__mentions .user-details:nth-child(odd)').addClass('bounceInLeft');
    $('.social__mentions .user-details:nth-child(even)').addClass('bounceInRight');
}

function trackFriends() {
    if ( !map_active )
    {
        capture_user_location();
    }
}